export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytváření widgetu pro"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušení"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vygenerovat"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platba v"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Částka platby"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Akce při úspěchu"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Akce při neúspěchu"])}
}